import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

class BookingBreadcrumb extends Component {

  constructor(props) {
    super(props)
    this.state = {
      step: props.step,
      items: [

        <FormattedMessage
          id="booking.breadcrumb.login"
          defaultMessage="Login"
        />,
        <FormattedMessage
          id="booking.breadcrumb.participants"
          defaultMessage="Participants"
        />,
        <FormattedMessage
          id="booking.breadcrumb.dateTime"
          defaultMessage="Date & time"
        />,
        <FormattedMessage
          id="booking.breadcrumb.passes"
          defaultMessage="Passes & Party"
        />,
        <FormattedMessage
          id="booking.breadcrumb.personal"
          defaultMessage="Personal information"
        />,
        <FormattedMessage
          id="booking.breadcrumb.checkout"
          defaultMessage="Checkout"
        />
      ]
    }
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
  }

  componentWillMount() {
    const { booking } = this.props
    const {items} = this.state

    if (booking.invitation) {
      items.splice(1, 2)
      if (booking.loggedInAtBeginning) {
        items.splice(2, 1)
      }
    } else {
      if (booking.loggedInAtBeginning) {
        // remove 'Personal info' step
        items.splice(4, 1)
      } else {
        // remove 'Participants' step
        items.splice(1, 1)
      }
    }
    
    this.setState({ items })
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  listItem(item, index) {
    const {step, items} = this.state
    const shouldDisable = step <= index
    const isActive = index+1 === step
    const isCompleted = step > index+1
    const leftStripeCss = () => {
      if (index === 0) {
        return ''
      }
      return (shouldDisable ? 'bg-stripe-hz-harbor-60' : 'bg-stripe-hz-harbor')
    }
    const rightStripeCss = () => {
      if (index + 1 === items.length) {
        return ''
      }
      if (isActive || !isCompleted) {
        return 'bg-stripe-hz-harbor-60'
      }
      return 'bg-stripe-hz-harbor'
    }

    return (
      <li 
        className={`flex-1 text-xs py-4 font-bold text-center ${shouldDisable ? 'text-harbor-60' : 'text-harbor'}`}
        key={this.getKey()}
      >
        <div className="flex">
          <div className={`flex-grow ${leftStripeCss()}`} />
          <div className={`${shouldDisable ? 'border-harbor-60' : 'border-blue-darkest'} rounded-full mx-auto mb-2 border-solid border-2 h-8 w-8`}>
            <div className={`${isCompleted && 'bg-sky border-2'} w-full h-full rounded-full flex items-center justify-center`}>
              {isCompleted ? (
                <svg className="fill-current h-3 w-3 text-aluminium" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
                </svg>        
              ) : (
                index+1
              )}
            </div>
          </div>
          <div className={`flex-grow ${rightStripeCss()}`} />
        </div>
        <div className={`${shouldDisable && 'text-harbor-60}'}`}>
          {item}
        </div>
      </li>        
    )
  }

  render() {
    const {items} = this.state
    return (
      <div 
        className=""
        style={{ backgroundColor: '#e6e6e6'}}
      >
        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
            <ul
              className="list-reset flex"
              style={{width: '115%', marginLeft: '-9%'}} // Mkay, little hackish
            >
              {items.map((item, index) => this.listItem(item, index))}
            </ul>
          </div>
        </div>    
      </div>     
    )
  }
}

BookingBreadcrumb.propTypes = {
  booking: PropTypes.shape({
    booking: PropTypes.object
  }).isRequired,
  step: PropTypes.number.isRequired
}

// BookingBreadcrumb.defaultProps = {}

export default BookingBreadcrumb